import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "blacklist-info",
  ref: "blacklist-info",
  class: "p-7"
}
const _hoisted_2 = { class: "bg-h-primary-50 p-5 border-2 border-h-primary-100 rounded-md flex justify-between items-start" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex gap-3 items-center" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ml-5" }
const _hoisted_7 = { class: "col-span-12" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_10 = {
  class: /*#__PURE__*/_normalizeClass(`mb-2`)
}
const _hoisted_11 = { class: "col-span-12" }
const _hoisted_12 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Topbar = _resolveComponent("Topbar")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Adaptive = _resolveComponent("Adaptive")!
  const _component_Traditional = _resolveComponent("Traditional")!
  const _component_MaterialModal = _resolveComponent("MaterialModal")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.role == 'TEACHER' && _ctx.data.adaptive)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: require('../../../assets/images/blacklist.svg')
                }, null, 8, _hoisted_5),
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Analisar palavras chaves",
                  en: "Analyze keywords",
                })), 1)
              ]),
              _createElementVNode("h6", _hoisted_6, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Os alunos poderão clicar nas palavras-chaves geradas dos vídeos e ver conteúdos relacionados, faça a análise desses itens, clique dentro dos objetivos, na opção “Analisar palavras-chaves”.",
                en: "Students will be able to click on the keywords generated from the videos and see related content, analyze these items, click within the objectives, on the “Analyze keywords” option.",
              })), 1)
            ]),
            _createVNode(_component_Button, {
              icon: "pi pi-times",
              class: "btn-simple p-button-sm",
              onClick: _ctx.closeInfo
            }, null, 8, ["onClick"])
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_Topbar, {
      data: _ctx.data,
      role: _ctx.user.role,
      onOpenAdaptiveChapter: _ctx.openModalChapter
    }, null, 8, ["data", "role", "onOpenAdaptiveChapter"]),
    _createVNode(_component_Loader, { loader: _ctx.loader }, null, 8, ["loader"]),
    (_ctx.data.adaptive && !_ctx.loader)
      ? (_openBlock(), _createBlock(_component_Adaptive, {
          key: 1,
          ref: "adaptive",
          graph: _ctx.graph,
          role: _ctx.user.role,
          onOnAddChapter: _ctx.openModalChapter,
          onOnAddObjective: _ctx.addObjective,
          onOnEditObjective: _ctx.editObjective,
          onOnShowObjects: _ctx.getObjectsByLearningObjective,
          onOnShowBlacklist: _ctx.goToBlacklist
        }, null, 8, ["graph", "role", "onOnAddChapter", "onOnAddObjective", "onOnEditObjective", "onOnShowObjects", "onOnShowBlacklist"]))
      : _createCommentVNode("", true),
    (!_ctx.data.adaptive && !_ctx.loader)
      ? (_openBlock(), _createBlock(_component_Traditional, {
          key: 2,
          role: _ctx.user.role,
          data: _ctx.data
        }, null, 8, ["role", "data"]))
      : _createCommentVNode("", true),
    (_ctx.configModal.showMaterials)
      ? (_openBlock(), _createBlock(_component_MaterialModal, {
          key: 3,
          materials: _ctx.materials,
          learningObjective: _ctx.learningObjective,
          config: _ctx.configModal,
          onOnChooseMaterial: _ctx.getObjectsByLearningObjective,
          onOnCloseMaterialsModal: _ctx.closeMaterialsModal,
          onOnGoToObjective: _ctx.goToObjective,
          userRole: _ctx.user.role
        }, null, 8, ["materials", "learningObjective", "config", "onOnChooseMaterial", "onOnCloseMaterialsModal", "onOnGoToObjective", "userRole"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      visible: _ctx.displayModal,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.displayModal) = $event)),
      header: 
        _ctx.chapterModal?.name == '' ? _ctx.$t('chapters.add') : _ctx.$t('chapters.edit')
      ,
      draggable: false,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '40vw' },
      modal: true,
      class: "custom-modal",
      onHide: _cache[9] || (_cache[9] = ($event: any) => (_ctx.closeModalChapter()))
    }, {
      footer: _withCtx(() => [
        (_ctx.user.role === 'TEACHER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "cancel-input",
              label: _ctx.$t('labels.cancel'),
              class: "btn-simple p-button-sm",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closeModalChapter()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.user.role === 'TEACHER')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              id: "save-input",
              label: _ctx.$t('labels.save'),
              class: "btn-primary p-button-sm",
              type: "submit",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submitChapter()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.user.role === 'ADMINISTRATOR')
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              id: "adm-btn",
              label: "OK",
              class: "btn-primary p-button-sm",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeModalChapter()))
            }))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.submitChapter()), ["prevent"])),
          class: "grid grid-cols-12 gap-5 pt-8 font-[600]",
          autocomplete: "off"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("chapters.form.name")), 1),
            _createVNode(_component_InputText, {
              disabled: _ctx.user.role === 'ADMINISTRATOR',
              id: "title-input",
              type: "text",
              name: "name",
              modelValue: _ctx.formChapter.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formChapter.name) = $event)),
              maxlength: 50,
              class: _normalizeClass(_ctx.v$.formChapter.name.$error ? 'p-invalid' : '')
            }, null, 8, ["disabled", "modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.formChapter.name.$errors,
              actualLength: _ctx.formChapter.name?.length,
              maxLength: 50
            }, null, 8, ["errors", "actualLength"])
          ]),
          (_ctx.formChapter?.id === '' && _ctx.chapters?.length !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("chapters.form.predecessor")), 1),
                _createVNode(_component_AutoComplete, {
                  id: "predecessor-input",
                  modelValue: _ctx.autocomplete.selected,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.autocomplete.selected) = $event)),
                  suggestions: _ctx.autocomplete.suggestions,
                  forceSelection: true,
                  onComplete: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForChapters($event))),
                  optionLabel: "name",
                  class: _normalizeClass(`w-full`)
                }, null, 8, ["modelValue", "suggestions"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("chapters.form.description")), 1),
            _createVNode(_component_Textarea, {
              id: "description-input",
              autoResize: true,
              rows: "5",
              cols: "30",
              modelValue: _ctx.formChapter.description,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formChapter.description) = $event)),
              class: _normalizeClass(_ctx.v$.formChapter.description.$error ? 'p-invalid' : ''),
              maxlength: 999,
              disabled: _ctx.user.role === 'ADMINISTRATOR'
            }, null, 8, ["modelValue", "class", "disabled"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.formChapter.description.$errors,
              actualLength: _ctx.formChapter.description?.length,
              maxLength: 999
            }, null, 8, ["errors", "actualLength"])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}